import { ConvertStringToHtmlId } from '../../libs/ts/ConvertStringToHtmlId';
import { FieldValues, Path, useFormContext } from 'react-hook-form';
import { FormComponentProps } from '../types';

interface FormCheckboxProps<T> extends FormComponentProps<T> {
  title: string;
  description?: string;
  group?: string;
}

export const FormCheckbox = <T extends FieldValues>(props: FormCheckboxProps<T>) => {
  const checkboxTitle = ConvertStringToHtmlId(props.title);

  const { register } = useFormContext<T>();
  const inputProps = register<Path<T>>(props.name);

  return (
    <div>
      <div className="flex flex-row w-full">
        <input
          {...inputProps}
          type="checkbox"
          id={checkboxTitle}
          name={props.name}
          readOnly={props.readonly}
          disabled={props.readonly}
          className="
            w-4 h-4 translate-y-1
            appearance-none
            bg-transparent
            border-2 border-secondary-deep-blue-30
            rounded-[2px]
            cursor-pointer
            relative

            hover:border-solid-bold-green
            checked:border-solid-bold-green
            checked:bg-solid-bold-green

            after:content-['']
            after:absolute
            after:hidden
            after:w-[4px]
            after:h-[8px]
            after:border-secondary-deep-blue-80
            after:border-r-2
            after:border-b-2
            after:rotate-45
            after:left-[5px]
            after:top-[1px]

            checked:after:block

            disabled:opacity-50
            disabled:cursor-not-allowed
          "
        />
        <label htmlFor={checkboxTitle} className="ml-7">
          {props.title}
        </label>
      </div>

      {props.description !== undefined && (
        <span
          className={`block whitespace-pre-wrap mt-3 mb-5 ml-8 mr-8 leading-6 text-sm text-secondary-deep-blue-20 font-italic overflow-hidden transition-[max-height] ease-in duration-300 max-h-0`}
        >
          {props.description}
        </span>
      )}
    </div>
  );
};
